/* eslint-disable @typescript-eslint/no-explicit-any */
import '../Styles/styles-legacy.scss';
import 'picturefill';

import gallery from './legacy/components/gallery';
import nav from './legacy/components/nav';
import parallax from './legacy/components/parallax';
import toggleNav from './legacy/components/toggleNav';

/**
 * Called once the page is loaded and handles initialising
 * the different components.
 */
const init = () => {
    gallery();
    nav();
    parallax();
    toggleNav();
};

const canInit = () => {
    const regReady = (window as any).attachEvent ? /d$|^c/ : /d$|^c|^i/;
    return regReady.test(document.readyState || '');
};

let timer: NodeJS.Timeout;

const checkCanInit = () => {
    if (canInit()) {
        if (timer) {
            clearTimeout(timer);
        }

        init();
        return;
    }

    timer = setTimeout(checkCanInit, 100);
};

checkCanInit();
